import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, List, ListItemButton, ListItemText } from '@mui/material';
import { apiService } from '../../services/apiService';
import { Link as RouterLink } from 'react-router-dom';

const Tags: React.FC = () => {
  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const resp = await apiService.listTags();
        if (cancelled) return;
        const list = Array.isArray(resp?.data?.items) ? resp.data.items : Array.isArray(resp?.data) ? resp.data : [];
        setItems(list);
      } catch (e: any) {
        if (!cancelled) setError(e?.message || 'Failed to load tags');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Tags</Typography>
      {error && <Typography color="error" variant="body2">{error}</Typography>}
      <Card>
        <CardContent>
          {loading ? (
            <Typography variant="body2" color="textSecondary">Loading…</Typography>
          ) : items.length === 0 && !error ? (
            <Typography variant="body2" color="textSecondary">No tags available.</Typography>
          ) : (
            <List>
              {items.map((t: any, idx: number) => (
                <ListItemButton component={RouterLink as any} to={`/tags/${t.slug}`} key={idx}>
                  <ListItemText primary={t.name || t.slug} secondary={t.description || `${t.bill_count ?? 0} bills`} />
                </ListItemButton>
              ))}
            </List>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default Tags;
